import React from 'react';
import Loader from '../../../loader';

const LoadingMessage = () => (
  <div className="ws-ui-base-select-loading-message">
    <Loader />
  </div>
);

export default LoadingMessage;
